import { render } from "./BasketOverlay.vue?vue&type=template&id=c1a35246&scoped=true&ts=true"
import script from "./BasketOverlay.vue?vue&type=script&lang=ts"
export * from "./BasketOverlay.vue?vue&type=script&lang=ts"

import "./BasketOverlay.vue?vue&type=style&index=0&id=c1a35246&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a35246"]])

export default __exports__